/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from "react";

import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { FieldMaps, generateOrderedFieldMap } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";
import { AllMerchantFields, Field, FieldSet } from "client/lib/apt-merchant";

const useStyles = makeStyles((theme) => {
  const { gray40, gray80, gray10 } = useNormalizedBrandPaletteValues(theme);

  return {
    label: {
      fontSize: "0.9rem",
      lineHeight: "1.4rem",
      color: gray40,
    },
    value: {
      color: gray10,
    },
    wrapper: {
      border: `1px solid ${gray80}`,
      borderRadius: theme.shape.borderRadius,
    },
  };
});

interface StaticFieldsToRender {
  fieldSet: FieldSet<any>;
  uiFieldMap?: FieldMaps;
}

export const StaticFieldRenderer: React.FC<StaticFieldsToRender> = ({
  fieldSet,
  uiFieldMap,
}) => {
  const classes = useStyles();
  if (!uiFieldMap) {
    return null;
  }

  const orderedUiFieldMap = generateOrderedFieldMap(uiFieldMap);

  const showFields = fieldSet.fields.filter((field) => field.shown);

  showFields.sort(
    (a, b) =>
      // @ts-ignore
      (orderedUiFieldMap?.[a.propertyName]?.order ?? 0) -
      // @ts-ignore
      (orderedUiFieldMap?.[b.propertyName]?.order ?? 0)
  );

  const getFieldValue = (field: Field<any>) => {
    if (field.uiFieldType === "FileUpload") {
      return "<file>";
    }
    return field.value;
  };

  return (
    <Box p={4} className={classes.wrapper}>
      <Grid container spacing={2}>
        {showFields.map((field) => (
          <Grid
            key={field.propertyName}
            xs={12}
            lg={
              // @ts-ignore
              orderedUiFieldMap?.[field.propertyName as keyof AllMerchantFields]
                ?.width ?? 6
            }
            item
          >
            <Box>
              <Typography className={classes.label} variant="caption">
                {field.i18nValues.label}
              </Typography>
              <Typography className={classes.value}>
                {getFieldValue(field)}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
